import type { SupportedLanguage } from "../api/userInfo";

export type FormatDateOptions = { showTime?: boolean };
export const formatDate = (
  dateString: string,
  locale: SupportedLanguage,
  { showTime }: FormatDateOptions = {}
): string => {
  const date = new Date(dateString);
  const { day, month, year } = Object.fromEntries(
    new Intl.DateTimeFormat(locale, { year: "numeric", month: "long", day: "numeric" })
      .formatToParts(date)
      .map(part => [part.type, part.value])
  );
  const formattedDate = `${day} ${month} ${year}`;
  if (!showTime) {
    return formattedDate;
  }
  const formattedTime = new Intl.DateTimeFormat(locale, {
    hour12: locale === "en",
    hour: "numeric",
    minute: "numeric",
  }).format(date);
  return `${formattedDate} ${formattedTime}`;
};
